// extracted by mini-css-extract-plugin
export default {"cell_wrapper":"ProjectProtocolsTableDummyCell_cell_wrapper__ZY3T4","loadingDummy":"ProjectProtocolsTableDummyCell_loadingDummy__xbWml"};